import m from "../../es2015/lang/ca_ES";
window.am4lang_ca_ES = m;


//////////////////
// WEBPACK FOOTER
// ./lang/ca_ES.js
// module id = null
// module chunks = 